import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { coreActions, coreSelectors } from '@/state/core';

import { useAppDispatch } from '.';

type UseResizeProps = {
    minWidth: number;
};

type UseResizeReturn = {
    width: number;
    enableResize: () => void;
};

const useDrawerResize = ({ minWidth }: UseResizeProps): UseResizeReturn => {
    const [isResizing, setIsResizing] = useState(false);
    const width = useSelector(coreSelectors.getDrawerWidth);
    const dispatch = useAppDispatch();

    const enableResize = useCallback(() => {
        setIsResizing(true);
    }, []);

    const disableResize = useCallback(() => {
        setIsResizing(false);
    }, []);

    const resize = useCallback(
        (e: MouseEvent) => {
            if (isResizing) {
                const newWidth = e.clientX; // You may want to add some offset here from props
                if (newWidth >= minWidth) {
                    dispatch(coreActions.resizeDrawer({ drawerWidth: newWidth }));
                }
            }
        },
        [isResizing, minWidth, dispatch]
    );

    useEffect(() => {
        document.addEventListener('mousemove', resize);
        document.addEventListener('mouseup', disableResize);

        return () => {
            document.removeEventListener('mousemove', resize);
            document.removeEventListener('mouseup', disableResize);
        };
    }, [disableResize, resize]);

    return { width, enableResize };
};

export default useDrawerResize;
